export default {"src":"/_next/static/image/public/images/ic_up_arrow_grey.f2bf6c3ca16f61caa9e046e5aeb6d421.svg","height":11,"width":19};